var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "235px",
    width: "235px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-36.99 -36.99 443.93 443.93",
    xmlSpace: "preserve",
    fill: "#39535C",
    stroke: "#39535C",
    transform: "rotate(0)",
    strokeWidth: 4.069406,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: ""
    },
    d: "M184.973,0C82.981,0,0,82.975,0,184.973s82.981,184.973,184.973,184.973 s184.973-82.975,184.973-184.973S286.965,0,184.973,0z M193.183,280.658H166.69V134.929h26.493V280.658z M179.334,110.244 c-9.332,0-15.961-7.226-15.961-16.266c0-9.326,6.928-16.558,16.558-16.558c9.941,0,16.26,7.232,16.26,16.558 C196.495,103.018,189.872,110.244,179.334,110.244z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.78c4bd8a9e08bba54a6ac45f5877a0b6.svg";
export { ForwardRef as ReactComponent };